import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

type UpdateSuggestionTemplateVariables = {
	entryId: string;
	subject?: string;
	content: Api.IRawRichTextContentState;
	templateId: string;
	impersonationContext: Api.IImpersonationContext;
};

export const useUpdateSuggestionTemplateMutation = ({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: unknown) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ entryId, subject, content, templateId, impersonationContext }: UpdateSuggestionTemplateVariables) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `ContentCalendarSuggestion/${entryId}/template`,
					impersonationContext,
				}),
				'PUT',
				{ subject, content, templateId }
			),
		onSuccess,
		onError,
	});
};
